(function () {
  const nf = new Intl.NumberFormat(); // for 1,160 formatting

  function updateBadge(el, priceCents) {
    const fixed = el.dataset.fixed && !isNaN(+el.dataset.fixed) ? +el.dataset.fixed : null;
    const mult = +el.dataset.multiplier || 40;
    const label = el.dataset.label || 'Entries';
    const badgeLabel = el.dataset.badgeLabel || (mult + 'x');

    const entries = fixed != null ? fixed : Math.round((priceCents * mult) / 100);
    const numEl = el.querySelector('.js-entries-number');
    const multEl = el.querySelector('.js-entries-mult');

    if (numEl) numEl.textContent = nf.format(entries);
    if (multEl) multEl.textContent = badgeLabel;
  }

  // Initial render for all badges (cards and PDP)
  document.querySelectorAll('.entries-badge').forEach(el => {
    const priceCents = +el.dataset.priceCents || 0;
    updateBadge(el, priceCents);
  });

  // Listen for variant changes on PDP and update entries accordingly
  // Works with common OS 2.0 themes (Dawn & similar)
  function wireVariantListeners() {
    document.querySelectorAll('.entries-variant-json').forEach(jsonEl => {
      const productId = jsonEl.dataset.productId;
      let variants = [];
      try { variants = JSON.parse(jsonEl.textContent); } catch(e) {}

      // Find the nearest badge for this product
      const badge = jsonEl.closest('section, form, div')?.querySelector('.entries-badge') ||
                    document.querySelector('.entries-badge');

      if (!badge || !variants.length) return;

      // Handler: whenever variant id input/select changes
      const forms = document.querySelectorAll(`form[action*="/cart/add"]`);
      forms.forEach(form => {
        form.addEventListener('change', (e) => {
          // Try to read current variant id from standard input/select name="id"
          const idInput = form.querySelector('input[name="id"][type="hidden"], select[name="id"]');
          if (!idInput) return;
          const vid = +idInput.value;
          const v = variants.find(x => x.id === vid);
          if (v) updateBadge(badge, +v.price_cents || 0);
        });
      });

      // Fallback: observe price DOM changes (some themes update price without changing id input immediately)
      const priceTarget = document.querySelector('[data-product-price], .price-item--regular, .product__price');
      if (priceTarget) {
        const mo = new MutationObserver(() => {
          // keep current dataset price if we can't read variant; this is just a failsafe
          const current = +badge.dataset.priceCents || 0;
          updateBadge(badge, current);
        });
        mo.observe(priceTarget, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireVariantListeners);
  } else {
    wireVariantListeners();
  }
})();